// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"123":"case","357":"casesFrame","794":"cases","933":"auth"}[chunkId] || chunkId) + "." + {"123":"af378160","163":"cbe631b9","288":"8f5711f4","357":"50a4a9b2","508":"91d43c15","794":"50c1e7f8","854":"d45f0bd9","865":"27acea7b","915":"6fb4a13e","933":"3ade168d","986":"1eadeede"}[chunkId] + ".js";
};